<template>
    <div class="login-page">
        <div class="login-header">欢迎使用智慧任务平台</div>
        <div class="login-form-container">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login-form" label-position="top">
                <el-form-item prop="username" label="账户">
                    <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                    <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" auto-complete="off"
                        @keyup.enter.native="submitForm('ruleForm')"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center">
                    <el-button type="primary" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            logining: false,
            ruleForm: {
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            }
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.logining = true
                    this.$store.dispatch('Login', this.ruleForm).then((res) => {
                        if (res.errno === 0) {
                            this.logining = false;
                            this.$message({
                                type: "success",
                                message: '登录成功'
                            })
                            if (res.data.roles[0].slug == 'administrator' && localStorage.getItem('queryId')) {
                                setTimeout(() => {
                                    this.$nextTick(() => {
                                        this.$router.push({ path: '/unicomData/audits' })
                                    })
                                }, 1000)
                            }
                            else {
                                setTimeout(() => {
                                    this.$nextTick(() => {
                                        this.$router.push({ path: '/unicomData/fenceUpload' })
                                    })
                                }, 1000)
                            }
                        } else {
                            this.$message.error(res.error)
                            this.logining = false
                        }
                    }).catch(() => {
                        this.logining = false
                    })
                } else {
                    // 获取图形验证码
                    this.$message.error('请输入用户名密码！')
                    this.logining = false
                    return false
                }
            })
        }
    }
};
</script>
<style scoped>
.login-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url("../../assets/img/smart_platform.jpeg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.login-header {
    font-size: 30px;
    line-height: 80px;
    margin-top: 100px;
    margin-bottom: 20px;
}

.login-form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.login-form {
    width: 100%;
    max-width: 300px;
    border: 1px solid #dcdfe6;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;
    background: #fff;
}

.login-form>>>.el-button {
    width: 100px;
    padding: 0;
    background-color: #3998f7;
    border: none;
}

@media screen and (min-width: 2000px) {
    .login-header {
        margin-top: 150px;
        margin-bottom: 60px;
        font-size: 45px;
    }

    .login-form>>>.el-button {
        width: 150px;
        font-size: 18px;
    }

    .login-form>>>.el-form-item__label {
        font-size: 18px;
    }

    .login-form>>>.el-input__inner {
        font-size: 18px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/unicomData/unicomLogin.vue